/* マイページ開設同意確認画面 */
import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import axios from '../axios';
import HtmlParser from '../molecules/HtmlParser';
import { Form } from 'react-bootstrap';
import Block from '../molecules/Block';
import LoadingModal from '../molecules/LoadingModal';
import { PostData } from '../types/MypageAgreement';
import { ResponseData } from '../types/MypageAgreement';
import { module_name, api_response_type } from '../Const';
import { handleBrowzerBack } from '../BrowzerBack';

interface Agreement {
  id: string;
  title: string;
  text: string;
  check_box_title: string;
  button_checked: boolean;
  checkbox_checked: boolean;
}

const MypageAgreementGuarantor: React.FC = () => {
  const [agreements, setAgreements] = useState<Array<Agreement>>([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();

    const getAgreement = async () => {
      try {
        setShow(true);
        const response = await axios.get('/agreement');
        setAgreements(response.data.agreements);
      } catch (error) {
        console.error(error);
      } finally {
        setShow(false);
      }
    };
    getAgreement();
  }, []);

  /**
   * 各同意文の同意状態を変更する
   *
   * @param event イベント
   */
  const handleClickAgreementButton = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const name = event.currentTarget.name;
    setAgreements((prev) =>
      prev.map((value) =>
        value.id === name
          ? {
              ...value,
              button_checked: true,
            }
          : value
      )
    );
  };

  /**
   * 各同意文チェックボックスのチェックを変更する
   *
   * @param event イベント
   * @return void
   */
  const handleChangeAgreementCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.currentTarget.name;
    setAgreements((prev) =>
      prev.map((value) =>
        value.id === name
          ? {
              ...value,
              checkbox_checked: !value.checkbox_checked,
            }
          : value
      )
    );
  };

  /**
   * 同意条件を確認する
   *
   * @returns boolean
   */
  const disabledNext = (): boolean => {
    return agreements.some((agreement) => agreement.button_checked === false);
  };

  /**
   * APIへリクエストを送る
   */
  const handleClickNext = () => {
    nextPage();
  };

  /**
   * ユーザー判別とマイページ作成状況確認
   */
  const nextPage = async () => {
    try {
      const details = agreements.map((agreement) => {
        return {
          id: agreement.id,
          checked: agreement.checkbox_checked,
        };
      });
      const post_data: PostData = {
        module_name: module_name.mypage_agreement,
        detail: details,
        is_json: true,
      };
      // APIにデータをPOSTする
      const response = await axios.post('/api/common/unauth', post_data);
      allocationResponseData(response.data);
    } catch (exception) {
      console.error(exception);
    }
  };

  /**
   * レスポンス値を元に処理を振り分ける
   *
   * @param {ResponseData} response_data レスポンスデータ
   * @param {PostData} post_data postしたデータ
   */
  const allocationResponseData = (response_data: ResponseData) => {
    if (response_data.result) {
      if (response_data.response_type === api_response_type.validation) {
        // エラーダイアログに表示するメッセージ文のJSX.Elementを生成する
        // エラーダイアログを表示する
      } else if (response_data.response_type === api_response_type.transition_to_login) {
        location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`;
      } else if (response_data.response_type === api_response_type.transition_to_password_regist) {
        location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/register/password`;
      }
    } else {
      // 例外発生
    }
  };

  return (
    <div id="mypage-agreement-guarantor">
      <div>
        <h4 className="font-weight-bold">同意書</h4>
      </div>
      <div>
        {agreements.map((agreement, index) => {
          return (
            <div key={index}>
              <Block label={agreement.title} content={<HtmlParser html={agreement.text} />} />
              <div className="block mx-auto col-xs-11 col-sm-11 col-md-8 col-11 px-0 text-start">
                <button
                  className="btn btn-main-color"
                  name={agreement.id}
                  disabled={agreement.button_checked}
                  onClick={handleClickAgreementButton}
                >
                  同意する
                </button>
              </div>

              {agreement.check_box_title && (
                <>
                  <br></br>
                  <label className="check-box-label">
                    <Form.Check
                      type="checkbox"
                      inline
                      name={agreement.id}
                      checked={agreement.checkbox_checked}
                      onChange={handleChangeAgreementCheck}
                      className="check-box"
                    />
                    {agreement.check_box_title}
                  </label>
                </>
              )}
            </div>
          );
        })}
      </div>
      <div>
        <a href="https://www.himegin.co.jp/personal/loan/housing/web_house/home_loan.html">
          「反社会的勢力に関する表明・確約条項」「マイページ利用規約」「個人情報の取扱いに関する同意事項は、愛媛銀行ホームページ」
        </a>
      </div>
      <button className="btn btn-main-color" disabled={disabledNext()} onClick={handleClickNext}>
        次へ
      </button>
      <LoadingModal show={show} />
    </div>
  );
};

const container = document.getElementById('mypage-agreement-guarantor');
if (container) {
  const root = createRoot(container);
  root.render(<MypageAgreementGuarantor />);
}
